import React, { lazy } from 'react';
import { Instagram, Facebook, Send, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-126">
      <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" data-id="element-127" />
    </svg>;
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-midnight text-ivory pt-24 pb-12 overflow-hidden mt-auto" data-id="element-128">
      <div className="max-w-7xl mx-auto px-6" data-id="element-129">
        {/* Huge Wordmark */}
        <div className="w-full text-center mb-16" data-id="element-130">
          <h2 className="text-[12vw] font-display font-black leading-none tracking-tighter text-ivory/5 select-none" data-id="element-131">
            CAMP DAVID
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12 items-center mb-16 border-b border-white/10 pb-16" data-id="element-132">
          <div className="flex items-center gap-4 justify-center md:justify-start" data-id="element-133">
            <img src="https://cdn.magicpatterns.com/uploads/sYKw6EQRHnT1SEh4hRD4M5/Camp_David_Logo.jpg" alt="Camp David Logo" className="h-16 w-auto object-contain rounded-full" loading="lazy" data-id="element-134" />
            <div className="flex flex-col" data-id="element-135">
              <span className="font-display font-bold text-2xl leading-tight tracking-tight" data-id="element-136">
                Camp David
              </span>
              <span className="text-[0.65rem] uppercase tracking-widest text-gold font-bold" data-id="element-137">
                Prayer Platform
              </span>
            </div>
          </div>

          <div className="text-center" data-id="element-138">
            <p className="text-lg font-medium text-ivory/70" data-id="element-139">
              Camp David Nation — <br data-id="element-140" />
              <span className="font-serif italic text-gold" data-id="element-141">
                A Global Endtime Army
              </span>
            </p>
          </div>

          <div className="flex items-center flex-wrap justify-center md:justify-end gap-3" data-id="element-142">
            <a href="mailto:campdavidprayerplatform@outlook.com" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-ivory hover:bg-gold hover:text-midnight transition-colors" aria-label="Email" data-id="element-143">
              <Mail className="w-5 h-5" data-id="element-144" />
            </a>
            <a href="https://www.instagram.com/campdavidprayerplatform?igsh=czk3cm92d3k2bnB2&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-ivory hover:bg-gold hover:text-midnight transition-colors" aria-label="Instagram" data-id="element-145">
              <Instagram className="w-5 h-5" data-id="element-146" />
            </a>
            <a href="https://www.facebook.com/share/18Uxv6Kc87/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-ivory hover:bg-gold hover:text-midnight transition-colors" aria-label="Facebook" data-id="element-147">
              <Facebook className="w-5 h-5" data-id="element-148" />
            </a>
            <a href="https://www.tiktok.com/@campdavidnation?_r=1&_t=ZS-96iUSUYiIqr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-ivory hover:bg-gold hover:text-midnight transition-colors" aria-label="TikTok" data-id="element-149">
              <TikTokIcon className="w-5 h-5" data-id="element-150" />
            </a>
            <a href="https://t.me/+clyrH4FDK9JlNmU8" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-ivory hover:bg-gold hover:text-midnight transition-colors" aria-label="Telegram" data-id="element-151">
              <Send className="w-5 h-5" data-id="element-152" />
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm font-medium text-ivory/50" data-id="element-153">
          <p data-id="element-154">
            © {currentYear} Camp David Prayer Platform. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-155">
            <Link to="/about" className="hover:text-gold transition-colors" data-id="element-156">
              About
            </Link>
            <Link to="/programs" className="hover:text-gold transition-colors" data-id="element-157">
              Programs
            </Link>
            <Link to="/articles" className="hover:text-gold transition-colors" data-id="element-158">
              Articles
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}